const ACCESS_STATUS_CACHE_KEY = "dople_access_status_v1";

export const ACCESS_STATUS_CACHE_TTL_MS = 31 * 24 * 60 * 60 * 1000;

const tokenSubject = (token) => {
  try {
    const payload = String(token || "").split(".")[1];
    if (!payload) return "";
    const unpadded = payload.replace(/-/g, "+").replace(/_/g, "/");
    const normalized = unpadded.padEnd(Math.ceil(unpadded.length / 4) * 4, "=");
    const decoded = JSON.parse(window.atob(normalized));
    return String(decoded.user_id || decoded.sub || "");
  } catch {
    return "";
  }
};

export function readCachedAccessStatus({
  token = "",
  maxAgeMs = ACCESS_STATUS_CACHE_TTL_MS,
} = {}) {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(ACCESS_STATUS_CACHE_KEY);
    if (!raw) return null;
    const cached = JSON.parse(raw);
    if (!cached || typeof cached !== "object" || !cached.status) return null;
    const currentSubject = tokenSubject(token);
    if (cached.subject && currentSubject && cached.subject !== currentSubject) {
      window.localStorage.removeItem(ACCESS_STATUS_CACHE_KEY);
      return null;
    }
    const verifiedAt = Number(cached.verified_at || 0);
    const fallbackExpiry = verifiedAt + Math.max(0, Number(maxAgeMs) || 0);
    const expiresAt = Number(cached.expires_at || fallbackExpiry);
    if (!verifiedAt || !expiresAt || Date.now() >= expiresAt) {
      return null;
    }
    return {
      ...cached.status,
      accessStatusVerifiedAt: verifiedAt,
      accessStatusCacheHit: true,
    };
  } catch {
    return null;
  }
}

export function writeCachedAccessStatus(status, { token = "" } = {}) {
  if (typeof window === "undefined" || !status || typeof status !== "object") return;
  try {
    const subject = tokenSubject(token);
    const verifiedAt = Date.now();
    const billingPeriodEnd = Date.parse(status.membershipCurrentPeriodEnd || "");
    const monthlyExpiry = verifiedAt + ACCESS_STATUS_CACHE_TTL_MS;
    const expiresAt = Number.isFinite(billingPeriodEnd) && billingPeriodEnd > verifiedAt
      ? Math.min(billingPeriodEnd, monthlyExpiry)
      : monthlyExpiry;
    window.localStorage.setItem(
      ACCESS_STATUS_CACHE_KEY,
      JSON.stringify({
        subject,
        verified_at: verifiedAt,
        expires_at: expiresAt,
        status,
      })
    );
  } catch {
    // Navigation still works without persistent browser storage.
  }
}

export function clearCachedAccessStatus() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(ACCESS_STATUS_CACHE_KEY);
  } catch {
    // Best-effort session cleanup.
  }
}
